import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { es } from './core';
import { SpinnerService } from './shared';
import { PrimeNG } from 'primeng/config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  standalone: false,
})
export class AppComponent {
  title = 'Contreras Hnos';

  private readonly primeConfig = inject(PrimeNG);

  private readonly spinner = inject(SpinnerService);

  private readonly cdr = inject(ChangeDetectorRef);

  showSpinner = false;
  ngOnInit() {
    //! TODO migrated to v18 @primeng
    this.primeConfig.ripple.set(true);
    this.primeConfig.setTranslation(es);

    /** @description Nos suscribimos a los cambios del spinner para mostrarlo o no */
    this.spinner.isLoading.subscribe((isLoading) => {
      if (!isLoading)
        //* Le ponemos un timeout para que se muestre la animación del leave
        setTimeout(() => {
          this.showSpinner = isLoading;

          this.cdr.detectChanges();
        }, 200);
      else this.showSpinner = isLoading;

      this.cdr.detectChanges();
    });
  }
}
